import { render, staticRenderFns } from "./Wordgame.vue?vue&type=template&id=a3bd5340&"
import script from "./Wordgame.vue?vue&type=script&lang=js&"
export * from "./Wordgame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports